import { Box } from '@mui/material';
import * as loadingAnimationData from 'core/assets/lottie/green-loader-animation.json';
import BaseImage from 'core/components/image/BaseImage';
import LottieAnimation from 'core/layouts/components/lottie-animation/LottieAnimation';
import React, { useCallback, useEffect, useRef, useState } from 'react';

function BaseImageWithLoader({ imageProps, skeletonStyles }) {
	const { onLoad, src } = imageProps;
	const imageRef = useRef(null);
	const [isLoaderShown, setIsLoaderShown] = useState(false);
	const onImageLoad = useCallback(
		(e) => {
			if (typeof onLoad === 'function') {
				onLoad(e);
			}
			setIsLoaderShown(false);
		},
		[onLoad],
	);
	useEffect(() => {
		if (src) {
			if (imageRef?.current?.complete) {
				setIsLoaderShown(false);
			} else {
				setIsLoaderShown(true);
			}
		}
	}, [src]);
	return (
		<Box
			sx={[
				{
					position: 'relative',
					display: 'contents',
				},
				isLoaderShown && skeletonStyles,
			]}
		>
			{/* eslint-disable-next-line react/jsx-props-no-spreading */}
			<BaseImage {...imageProps} ref={imageRef} onLoad={onImageLoad} />
			<Box
				sx={{
					position: 'absolute',
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					display: isLoaderShown ? 'flex' : 'none',
					justifyContent: 'center',
					alignItems: 'center',
					backgroundColor: 'rgba(0, 0, 0, 0.3)',
					'& div': {
						transform: 'scale(0.6)',
					},
				}}
			>
				<LottieAnimation animationData={loadingAnimationData} loop />
			</Box>
		</Box>
	);
}

export default BaseImageWithLoader;
